function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4375 10.0744C23.0305 10.0744 22.6975 10.4074 22.6975 10.8144V13.1834C22.6975 13.5904 23.0305 13.9234 23.4375 13.9234C23.8445 13.9234 24.1775 13.5904 24.1775 13.1834V10.8144C24.1775 10.4074 23.8445 10.0744 23.4375 10.0744Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.103 1.306H26.084V22.522H14.103V1.306ZM1.48 1.306H12.82V22.522H1.48V1.306ZM26.285 0H1.175C0.526 0 0 0.585 0 1.306V21.996V22.693V22.923V23.507V23.598C0 23.654 0.011 23.706 0.031 23.754C0.092 23.898 0.235 23.999 0.401 23.999H1.175H26.285H27.163H27.164C27.219 23.999 27.271 23.988 27.319 23.968C27.463 23.907 27.564 23.764 27.564 23.598V23.507V22.923V21.996V1.306C27.564 0.585 26.991 0 26.285 0Z",
  fill: "black"
});

function SvgDoorSliderClosed(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorSliderClosed);
export default __webpack_public_path__ + "static/media/door-slider-closed.552088f1.svg";
export { ForwardRef as ReactComponent };